var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('w-loader-full'):(_vm.surveys.length)?_c('div',{staticClass:"container-fluid my-3"},[_c('w-surveys-list',{attrs:{"surveys":_vm.surveys}})],1):_c('w-page-error',{attrs:{"message":"SX_LANG_COMPANY_SURVEYS_LIST_EMPTY"}})}
var staticRenderFns = []

export { render, staticRenderFns }